import React from 'react';
import PropTypes from 'prop-types';
import { PlusIcon } from '@heroicons/react/24/outline';

/**
 * Add Widget Placeholder
 * Shown in empty grid positions during edit mode
 * Matches design system "Widget Add Widget" component
 * 
 * Design specs:
 * - Height: 400px
 * - Centered content
 * - Plus icon 48x48
 * - "Add Widget" text, Roboto 32px bold
 */
const AddWidgetPlaceholder = ({ onClick, className = '' }) => {
  return (
    <button
      onClick={onClick}
      className={`
        h-[400px] w-full
        flex flex-col items-center justify-center gap-5
        bg-white border-2 border-dashed border-gray-300 rounded-lg
        hover:border-indigo-400 hover:bg-indigo-50/50
        transition-colors cursor-pointer
        focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2
        ${className}
      `}
      aria-label="Add widget to this position"
    >
      <div className="w-12 h-12 flex items-center justify-center">
        <PlusIcon className="h-10 w-10 text-gray-700 stroke-2" />
      </div>
      <span 
        className="text-[32px] font-bold leading-tight text-black"
        style={{ fontFamily: 'Roboto, sans-serif' }}
      >
        Add Widget
      </span>
    </button>
  );
};

AddWidgetPlaceholder.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default AddWidgetPlaceholder;
